import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { IconButton, Checkbox } from 'material-ui';
import Details from './Misc/Details';
import _ from 'lodash';
import KeyboardArrowDownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import KeyboardArrowUpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

const styles = {
    checkbox: {
        labelStyle: { fontSize: '14px' },
        style: { width: '750px' },
    },
    icon: {
        iconStyle: { color: '#00bcd4' },
    },
};


const LiftAndCranesForm = ({
    liftsCranes, onSubmit, onCancel,
}) => {
    const [values, setValues] = useState(liftsCranes);

    const handleSubmit = () => {
        onSubmit(values);
    };

    const items = React.useMemo(
        () => 
            Object.entries(values).map(([key, value]) => ({
                ...value,
                name: key,
                label: `${key} mt:`,
            })), 
        [values],
    );

    console.log('values', values);

    return (
        <div>
            <div className='lift-and-cranes'>
                {items.map((liftCrane, index) => (
                    <LiftAndCranesItem
                        key={`${liftCrane.id || index}`}
                        liftCrane={liftCrane}
                        liftsCranes={values}
                        changePort={setValues}
                    />
                ))}
            </div>
            <div className='form-actions'>
                <RaisedButton
                    label='Save'
                    primary
                    onClick={handleSubmit}
                />
                <RaisedButton
                    label='Cancel'
                    onClick={onCancel}
                    style={{ marginRight: '10px' }}
                    secondary
                />
            </div>
        </div>
    );
};

LiftAndCranesForm.propTypes = {
    liftsCranes: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

export default LiftAndCranesForm;

const LiftAndCranesItem = ({ liftCrane, liftsCranes, changePort }) => {
    const [showDetails, setShowDetails] = React.useState(false);

    const toggleDetails = React.useCallback(() => {
        setShowDetails(prev => !prev);
    }, []);

    const handleChangeVal = React.useCallback((val, name) => {
        const _liftsCranes = _.cloneDeep(liftsCranes);

        const updatedCrane = {
            ..._liftsCranes[name],
            checked: val,
        };

        if (!updatedCrane.checked) {
            updatedCrane.details = [];
        }

        changePort({
            ..._liftsCranes,
            [name]: updatedCrane,
        });
    }, [liftsCranes, changePort]);

    const { min, max } = React.useMemo(() => {
        if (!liftCrane.name) return { min: 0, max: 100 };
        const [minStr, maxStr] = liftCrane.name.split('-');
        return {
            min: parseInt(minStr, 10) || 0,
            max: parseInt(maxStr, 10) || 100,
        };
    }, [liftCrane.name]);

    const handleChangeDetails = (updatedDetails) => {
        changePort({
            ...liftsCranes,
            [liftCrane.name]: {
                ...liftCrane,
                details: updatedDetails,
            },
        });
    };

    return (
        <React.Fragment>
            <div className='line-head'>
                <div className='row'>
                    <div className='col-xs-12 middle-xs'>
                        <Checkbox
                            name={`liftsCranes.${liftCrane.name}.checked`}
                            label={liftCrane.label}
                            labelStyle={styles.checkbox.labelStyle}
                            style={styles.checkbox.style}
                            onCheck={(e, val) => handleChangeVal(val, liftCrane.name)}
                            checked={liftCrane.checked}
                        />

                        <div 
                            className={liftCrane.checked ? 'more' : 'hidden more'} 
                            onClick={toggleDetails}
                        >
                            More details
                        </div>

                        {liftCrane.checked && (
                            <IconButton
                                iconStyle={styles.icon.iconStyle}
                                onClick={toggleDetails}
                            >
                                {showDetails ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        )}
                    </div>
                </div>
            </div>

            <div className={showDetails && liftCrane.checked ? 'line-body' : 'hidden'}>
                <Details
                    details={liftCrane.details}
                    onAdd={(newDetail) => {
                        const updatedDetails = [...liftCrane.details, newDetail];
                        handleChangeDetails(updatedDetails);
                    }}
                    onEdit={(editedDetail, index) => {
                        const updatedDetails = [...liftCrane.details];
                        updatedDetails[index] = editedDetail;
                        handleChangeDetails(updatedDetails);
                    }}
                    onDelete={(index) => {
                        const updatedDetails = liftCrane.details.filter((_, i) => i !== index);
                        handleChangeDetails(updatedDetails);
                    }}
                    name={liftCrane.name}
                    min={min}
                    max={max}
                />
            </div>
        </React.Fragment>
    );
};

LiftAndCranesItem.propTypes = {
    liftCrane: PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        checked: PropTypes.bool,
        details: PropTypes.array,
    }).isRequired,
    liftsCranes: PropTypes.object.isRequired,
    changePort: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesForm.jsx